import topApi from '../api/ToPApi';

/**
 * Guías de uso que el usuario ya vio (terminó u omitió). Se guardan en su usuario (API /user/guides), así cada guía se
 * muestra una sola vez sin importar el navegador o el equipo. El navegador guarda una copia por si el API no responde.
 * Códigos: 'portal' (guía general) o el id de la pantalla ('products', 'stocks', 'loyalty', ...).
 */
const localKey = (userId: number, code: string) => `app-tour-seen-${userId}-${code}`;
// Claves anteriores, cuando solo se guardaba en el navegador
const legacyKey = (userId: number, code: string) =>
    code === 'portal' ? `app-tour-done-${userId}` : `app-page-tour-done-${code}-${userId}`;

const readLocal = (userId: number, code: string) => {
    try {
        return localStorage.getItem(localKey(userId, code)) === '1' || localStorage.getItem(legacyKey(userId, code)) === '1';
    } catch { return false; }
};
const saveLocal = (userId: number, code: string) => {
    try { localStorage.setItem(localKey(userId, code), '1'); } catch { /* sin almacenamiento */ }
};

// Una sola consulta por usuario mientras la página está abierta
let cache: { userId: number; seen: Promise<Set<string>> } | null = null;

const loadSeen = (userId: number) => {
    if (cache?.userId !== userId) {
        cache = {
            userId,
            seen: topApi.get<{ guides?: string[] }>('/user/guides')
                .then(resp => new Set(resp.data?.guides ?? []))
                .catch(() => new Set<string>()),     // sin API: decide la copia del navegador
        };
    }
    return cache.seen;
};

export const markTourSeen = (userId: number, code: string) => {
    saveLocal(userId, code);
    loadSeen(userId).then(seen => seen.add(code));
    topApi.post('/user/guides', { code }).catch(() => { /* queda la copia del navegador */ });
};

export const isTourSeen = async (userId: number, code: string) => {
    const seen = await loadSeen(userId);
    if (seen.has(code)) return true;
    if (readLocal(userId, code)) {
        // La vio en este navegador antes de que se guardara en su usuario: se guarda ahora
        markTourSeen(userId, code);
        return true;
    }
    return false;
};
